export default __webpack_public_path__ + "static/media/sourceOfMeet.6f11af4e.jpeg";